import "./geoEvent.scss";
import VerifiedIcon from '@mui/icons-material/Verified';
import VerifiedOutlinedIcon from '@mui/icons-material/VerifiedOutlined';
import TextsmsOutlinedIcon from "@mui/icons-material/TextsmsOutlined";
import ShareOutlinedIcon from "@mui/icons-material/ShareOutlined";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import { Link } from "react-router-dom";
import { useState, useEffect } from "react";
import MapWithCircles from "../geoMap/GeoMap";
// import { reverseGeocode } from '../geoMap/reverseGeoCode';


const GeoEvent = ({ post }) => {
  const [bodyOpen, setBodyOpen] = useState(false);
    
  const verified = false; // Temporary hardcoded verification status

  // Function to toggle body visibility
  const toggleBody = () => {
    setBodyOpen(!bodyOpen);
  };

  return (
    <div className="event">
      <div className="container">
        {/* Post Head */}
        <div style={{display: "flex", flexDirection: "row", justifyContent: "space-between"}}>
          <p>Geo Request({post.id}) {post.status} </p>
          <p>{post.timestamp}</p>
        </div>
        <div className="header" onClick={toggleBody}>
          <div className="headLeft userInfo">
            <span><Link to={`/target/${post.target_id}`}>Target: {post.target_name}</Link></span>
            <p>msisdn: {post.msisdn}</p>
            {post.imsi && (<p>imsi: {post.imsi}</p>)}
            {post.imei && (<p>imei: {post.imei}</p>)}
          </div>
          <div className="headRight">
            <p>Operator: {post.operator}</p>
            <p>mcc: {post.mcc}</p>
            <p>mnc: {post.mnc}</p>
            <p>lac: {post.lac}</p>
            <p>cellid: {post.cellid}</p>
            <p>band: {post.band}</p>
          </div>
          <div className="reverseGeo">
            <p>{post.data?.location?.reverse_geo}</p>
          </div>
          {post.data && post.data.location ?<MoreHorizIcon />: post.status }
        </div>

        {/* Post Body - Map and content */}
        {bodyOpen && (
          <div className="body">
            <div className="map">
              {/* Hardcoded Map Placeholder */}
              <div className="mapContainer">
                {/* Map Details */}
                { post.data && post.data.location && (
                  <><div className="mapDetails">
                  <span>Latitude: {post.data.location.lat}</span>
                  <span>Longitude: {post.data.location.lng}</span>
                  <span>Radius: {post.data.location.radius}m</span>
                  <span>Azimuth: {post.data.location.azimuth}</span>
                  <span><a href={ "https://maps.google.com/?q=" + post.data.location.lat + "," + post.data.location.lng} target="_blank" rel="noreferrer">Google maps</a></span>
                </div>
                <div className="mapPlaceholder">
                <MapWithCircles lat={post.data.location.lat} lng={post.data.location.lng} radius2={post.data.location.radius} radius1={Math.round(post.data.location.radius/2)}/>
                </div></>
        )}
                
              </div>
            </div>
           
          </div>
        )}
      </div>
      <div className="info">
              <div className="item">
                {verified ? <VerifiedIcon /> : <VerifiedOutlinedIcon />}
                3 Verifications
              </div>
              <div className="item">
                <TextsmsOutlinedIcon />
                12 Comments
              </div>
              <div className="item">
                <ShareOutlinedIcon />
                Share
              </div>
            </div>
    </div>
  );
};

export default GeoEvent;